/** @depecated: Используйте vue-i18n $n */
export const numberFormatter = Intl.NumberFormat('ru-RU');
